import { render, staticRenderFns } from "./QuestionsRefus.vue?vue&type=template&id=0184ee60&scoped=true"
import script from "./QuestionsRefus.vue?vue&type=script&lang=js"
export * from "./QuestionsRefus.vue?vue&type=script&lang=js"
import style0 from "./QuestionsRefus.vue?vue&type=style&index=0&id=0184ee60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0184ee60",
  null
  
)

export default component.exports